import React, { Component } from "react";
import "../initialPage/initial.scss";
import { Container, Row } from 'bootstrap-4-react';
import { withRouter } from "react-router-dom";
//Verification auth's
import { verifica } from "../../auth";


class RedirectorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flagEnd: false,
      countProgress: 0,
      autoload: 0,
    }
    
  }

  componentDidMount() {
    const { autoload } = this.state

    setTimeout(() => {
      if(autoload === 1) {
        this.setPreloaderFunct()
      } else if(autoload === 0) {
        this.verifyAuth()
      }
    }, 400)
  }

  setPreloaderFunct() {
    const { flagEnd, countProgress } = this.state

    if(!flagEnd) {

      if(countProgress < 100) {
        this.setState({
          countProgress: (countProgress + 1),
        })

        setTimeout(() => {
          this.setPreloaderFunct()
        }, 10)
      } else {
        this.setState({
          flagEnd: true,
          countProgress: 100,
        })

        setTimeout(() => {
          // this.initsetState({ viewApp: '' })
          this.verifyAuth()
        }, 300)
      }
    }
  }

  verifyAuth() {
    //Set localiting storage
    let param = window.location.search;

    const { debug } = this.props.initState
    // if(param === '') {
      //Si es vacío lo reubicamos
      verifica()
      .then( res => {

        //Checamos si desea ir a facturación en línea
        if( param.indexOf('?facturacion') !== -1 ) {
          this.props.initsetState({ viewApp: 'facturacion', })
        } else {

          if(!res) {
            //Redireccionamos a login
            this.props.history.push('/login')
            this.props.initsetState({viewApp: 'login'})
          } else {
            this.props.initState.socket.on("connect", this.props.nodeListener)

            if(res.type === 1) {
              //Admin


              let URL = `${window.location.pathname}${debug == 1 ? 'debug' : ''}`
              this.props.history.push(`${URL}`)
              this.props.initsetState({ signedIn: res, viewApp: 'director', })
            } else if(res.type === 2) {
              //Ejecutivo
              let URL = debug == 1 ? '?debug=1' : ''
              this.props.history.push(`/${URL}`)
              this.props.initsetState({
                signedIn: res,
                id_vendedor: res.id_usuario,
                id_sucursal: res.id_sucursal,
              })

              this.props.initsetState({ viewApp: 'ejecutivo',})
            } else if(res.type === 3) {
              //Control de productos
              let URL = debug == 1 ? '?debug=1' : ''
              this.props.history.push(`/${URL}`)
              this.props.initsetState({
                signedIn: res,
                id_usuario: res.id_usuario,
              })

              this.props.initsetState({ viewApp: 'control_productos',})
            } else if(res.type === 4) {
              //RH Contable
              let URL = debug == 1 ? '?debug=1' : ''
              this.props.history.push(`/${URL}`)
              this.props.initsetState({
                signedIn: res,
                id_usuario: res.id_usuario,
              })

              this.props.initsetState({ viewApp: 'rh_contable',})
            } else if(res.type === 5) {
              //Control de altas y costos por sucursal exclusivo
              let URL = debug == 1 ? '?debug=1' : ''
              this.props.history.push(`/${URL}`)
              this.props.initsetState({
                signedIn: res,
                id_usuario: res.id_usuario,
                id_sucursal: res.id_sucursal,
              })
              this.props.initsetState({ viewApp: 'control_sucursal',})
            }
          }
        }
      })
    // }
  }

  render() {
    const { countProgress } = this.state

    return (
      <Container className="splashPage__wrapper" style={{ background: '#fff', }} >
        {/* Principal Container */}
        <Row>
          <div style={{ margin: 20, alignItems: 'center', width: '100%', }}>
            {/*<p className="splashPage__text">Última actualización hace 20 horas</p>*/}
            <p style={{ color: '#000', width: '100%', textAlign: 'center', }} className="splashPage__text">Bienvenidos</p>
          </div>
        </Row>

        <Row>
          <div style={{ margin: 20, flex: 1, }}>
            <p style={{ color: '#000' }} className="splashPage__text">Cargando {countProgress}%</p>
            <div className="splashPage__loading">
              <div className="splashPage__loadingProgress" style={{ background: '#f3f3f3', width: `${countProgress < 99 ? countProgress : 99}%` }}></div>
            </div>
          </div>
        </Row>

        <Row>
          <div style={{ margin: 20, flex: 1, justifyContent: 'center', display: 'flex', }}>
            <img alt={"Logo"} src="img/pos/logow.png" className="splashPage__logo" />
          </div>
        </Row>
      </Container>
    );
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

};

export default withRouter(RedirectorPage)